import React, { useState, useRef } from 'react';
import { Search, X } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function SearchBar({ value, onChange, placeholder = 'Sök...', className = '' }: SearchBarProps) {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleCancel = () => {
    onChange('');
    setFocused(false);
    inputRef.current?.blur();
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative flex-1">
        <Search
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-tertiary)] pointer-events-none"
        />
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={e => onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => {
            if (!value) setFocused(false);
          }}
          placeholder={placeholder}
          className="w-full h-[44px] pl-9 pr-8 rounded-ios-input bg-[var(--bg-surface-alt)] text-[15px] text-[var(--text-primary)] placeholder-[var(--text-secondary)] outline-none focus:ring-2 focus:ring-[var(--ring-accent)] transition-all"
        />
        {value && (
          <button
            onClick={() => onChange('')}
            className="absolute right-0 top-1/2 -translate-y-1/2 min-h-[44px] min-w-[44px] flex items-center justify-center rounded-full focus-visible:ring-2 focus-visible:ring-[var(--ring-accent)]"
            aria-label="Rensa"
          >
            <span className="w-4 h-4 flex items-center justify-center rounded-full bg-[var(--text-tertiary)]/30">
              <X size={12} className="text-[var(--text-secondary)]" />
            </span>
          </button>
        )}
      </div>
      {focused && (
        <button
          onClick={handleCancel}
          className="text-accent-600 dark:text-accent-400 text-[15px] font-medium shrink-0 animate-fade-in"
        >
          Avbryt
        </button>
      )}
    </div>
  );
}
